import { Message } from '@material-ui/icons';
import {
    GET_FillExamcodes
} from '../constants/ActionTypes';

const INIT_STATE = {
    ExamCodes: '',
    //Message1:''
   
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillExamcodes:
            console.log(action, 'actionnn');
            return {
                ExamCodes: action.body,
               // Message1:action.msg
            }
        default:
            return state;
    }
}